import React from "react";

import { DISPENSARY_PLACEHOLDER_PHOTO } from "constants/dispensary";
import { Dispensary } from "custom-types/MenuItemCard";
import { formatMaxTimeEstimate } from "utils/formatMaxTimeEstimate";

import Image from "components/Image";

const HorizontalCardDeliveryFulfillmentInfo = ({
  dispensary,
}: {
  dispensary: Dispensary;
}) => {
  const {
    logoUrl,
    maxDeliveryDurationMaximum,
    maxOrderMinimum,
    name,
    userServiceArea,
  } = dispensary;

  //TODO: refactor to be passed in the backend
  const dispensaryImage = logoUrl || DISPENSARY_PLACEHOLDER_PHOTO;

  const formatDispensaryMaxDeliveryTime = formatMaxTimeEstimate(
    userServiceArea?.deliveryDurationMaximum || maxDeliveryDurationMaximum,
    "short",
  );

  const dispensaryOrderMinimum =
    (userServiceArea?.orderMinimum || maxOrderMinimum) &&
    `$${userServiceArea?.orderMinimum || maxOrderMinimum} min`;

  return (
    <div className="mt-sm flex" data-testid="menu-item-card__fulfillment">
      <div
        className="flex-shrink-0 pt-xs"
        style={{ height: "24px", width: "24px" }}
      >
        <Image
          src={dispensaryImage}
          alt={name}
          sizes={[24]}
          className="rounded"
        />
      </div>

      <div
        className="flex flex-col font-bold text-xs ml-md"
        data-testid="menu-item-card__delivery-info"
      >
        <div className="text-wrap">{name}</div>
        <span>
          {formatDispensaryMaxDeliveryTime}
          {/* \00A0 non breaking space */}
          <span className="leading-none after:content-['\00A0•\00A0']" />
          {dispensaryOrderMinimum !== 0 ? dispensaryOrderMinimum : "no minimum"}
        </span>
      </div>
    </div>
  );
};

export default HorizontalCardDeliveryFulfillmentInfo;
